<app-breadcrumb [pathList]="pathList"></app-breadcrumb>
<div [ngBusy]="{busy: busy, message: 'Loading...', backdrop: true, delay: 0, minDuration: 0}"></div>
<div class="container-fluid">
    <!-- {{matchdays_pl|json}} -->
    <div class="row d-flex justify-content-between" [formGroup]="searchForm">

        <div class="input-group input-group-sm  mb-1 item d-flex justify-content-start filtering">

            <input type="hidden" [formControlName]="'ctrl_page'" class="form-control">
            <input type="text" [formControlName]="'ctrl_description'" class="form-control" placeholder="Descrizione">
            <input type="text" [formControlName]="'ctrl_group_id'" class="form-control" placeholder="Gruppo">

            <!-- <input type="text" [formControlName]="col" class="form-control" placeholder="{{col.split('_')[1]}}"
                aria-label="Filtra per " aria-describedby="basic-addon2" *ngFor="let col of formControlsNames(searchForm.controls)" > -->
            <div class="input-group-append">
                <button class="btn btn-app" type="button" (click)="getList()" [disabled]="!Displayable">Filtra</button>
            </div>
        </div>
        <div class="input-group input-group-sm mb-1 item add-item">
            <div class="input-group-append">
                <button class="btn btn-app" type="button" (click)="navigateTo(0)">
                    <fa-icon [icon]="faPlus" [spin]="false"></fa-icon> Aggiungi
                </button>
            </div>
        </div>
    </div>
    <div *ngIf="!Displayable" class="emptyMessage">
    </div>
    <app-list-crest *ngIf="Displayable" [list]="list"  [cols]="cols" [componentService]="SponsorService" [routePart]="'sponsor'" 
        [paginationItems]="listPagination" (page)="page_nr($event)" (reloadList)="getList()" [itemType]="'Sponsor'" ></app-list-crest>
    <app-alertbox #alertbox1 [alerts]=""></app-alertbox>
</div>

<app-confirmation-dialog #one (dialogOutput)="dialogConfirm($event)">asd</app-confirmation-dialog>